import call from "../../../shared/service/http";
import TeamContants from "@/packages/team/TeamContants";

export default {
    namespaced: true,
    state: {
        teams: [],
    },
    mutations: {
        MUTATE: (state, payload) => {
            state[payload.state] = payload.data;
        },
    },
    getters: {
        TeamGetter: (state) => (setup) => state[setup],
    },
    actions: {
        /**
         *
         * @param commit
         */
        teams({commit}) {
            call('get', TeamContants.TEAM)
                .then(res=> {
                    if (res.data.success) {
                        commit("MUTATE", {
                            state: "teams",
                            data: res.data.data,
                        });
                    }
                    else{
                        Event.$emit("ApiError", 'Something went wrong');
                    }
                })
                .catch(err=>{
                    Event.$emit("ApiError", err.response.data.message);
                })
        },
        /**
         *
         * @param placeholder
         * @param payload
         */
        team({dispatch}, payload) {
            call('post', TeamContants.TEAM, payload)
                .then(res=> {
                    if (res.data.success) {
                        Event.$emit("ApiSuccess", res.data.message)
                        dispatch('teams')
                    }
                    else{
                        Event.$emit("ApiError", 'Something went wrong');
                    }
                })
                .catch(err=>{
                    Event.$emit("ApiError", err.response.data.message);
                })
        }
    }
}
